import React from 'react';
import useSiteState from '@app/state/SiteState';
import RegistrationState from '@app/model/authentication/RegistrationState';
import ProfileVerificationFlowPage from '@app/site/registration/flow/ProfileVerificationFlowPage';
import { Navigate } from 'react-router-dom';
import RegisterCompanyFlowPage from '@app/site/registration/flow/RegisterCompanyFlowPage';
import SelectSubscriptionPlanFlowPage from '@app/site/registration/fragment/SelectSubscriptionPlanFlowPage';
import ExecuteAccountSetupFlowPage from '@app/site/registration/flow/ExecuteAccountSetupFlowPage';
import { useSearchParam } from 'react-use';
import AddPropertiesFlowPage from '@app/site/registration/flow/AddPropertiesFlowPage';
import ParityUserWelcomeFlowPage from '@app/site/registration/flow/ParityUserWelcomeFlowPage';
import LatestProcessRequestExecutionStateMonitorProvider
	from '@app/site/secured/rateshopper/rates/provider/LatestProcessRequestExecutionStateMonitorProvider';

const RegistrationFlowPage = React.memo(() => {
	const siteState = useSiteState();
	const webhotelierId = useSearchParam('webhotelierId');

	let goto = <Navigate replace to="/sign-in" />;

	if (!!siteState.principal) {
		switch (siteState.principal.registrationState) {
			case RegistrationState.PENDING_VERIFICATION :
				goto = <ProfileVerificationFlowPage />;
				break;
			case RegistrationState.PENDING_COMPANY_REGISTRATION :
				goto = <RegisterCompanyFlowPage principal={siteState.principal!} onComplete={siteState.setPrincipal} />;
				break;
			case RegistrationState.PENDING_PARITY_PROPERTY :
				goto = <ParityUserWelcomeFlowPage />;
				break;
			case RegistrationState.PENDING_PROPERTIES :
				goto = <AddPropertiesFlowPage onComplete={siteState.setPrincipal} webhotelierId={webhotelierId} />;
				break;
			case RegistrationState.PENDING_HOTELS_ENRICH:
			case RegistrationState.PENDING_HOTELS_RANKING:
			case RegistrationState.PENDING_UPDATE_MARKET_STATE :
				goto = <LatestProcessRequestExecutionStateMonitorProvider><ExecuteAccountSetupFlowPage onComplete={siteState.setPrincipal} /></LatestProcessRequestExecutionStateMonitorProvider>;
				break;
			case RegistrationState.PENDING_SUBSCRIPTION_PLAN :
				goto = <SelectSubscriptionPlanFlowPage onComplete={siteState.setPrincipal} />;
				break;
			case RegistrationState.COMPLETED :
				goto = <Navigate replace to="/secured/dashboard" />;
				break;
		}

		return goto;

	}

	return goto;


});

export default RegistrationFlowPage;